var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    [
      _c("el-col", { attrs: { span: 24 } }, [
        _c("div", { staticClass: "agent-signin-grid-content" }, [
          _c(
            "div",
            { staticClass: "responsive-container" },
            [
              _c(
                "el-row",
                {
                  staticStyle: { display: "flex", "align-items": "center" },
                  attrs: { gutter: 30 }
                },
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column",
                        "align-items": "flex-start"
                      },
                      attrs: { span: 24 }
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c("span", { staticClass: "agent-question" }, [
                                _vm._v("Are you an agent?")
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-row",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "flex-start",
                                    "padding-top": "10px"
                                  }
                                },
                                [
                                  _c("el-col", { attrs: { span: 24 } }, [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "account-creation-instruction"
                                      },
                                      [
                                        _vm._v(
                                          "Sign in or create an account here"
                                        )
                                      ]
                                    )
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-row",
                                { staticStyle: { "padding-top": "10px" } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 6 } },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "agent-sign-in-btn",
                                          attrs: { type: "primary" },
                                          on: {
                                            click: _vm.redirectToAgentLogin
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                      Agent Sign in\n                    "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column",
                        "align-items": "flex-end"
                      },
                      attrs: { span: 12 }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: require("../../assets/unifi-logo-new.svg")
                        }
                      })
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f61a8c04", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f61a8c04","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/package/agentSignIn.vue
// module id = null
// module chunks = 